import { Component, Inject, OnInit, ViewChild } from '@angular/core';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as _ from 'lodash';
import { AppService } from 'src/app/app.service';

@Component({
    selector: 'app-payby-diners-dialog',
    templateUrl: './payby-diners-dialog.component.html',
    styleUrls: ['./payby-diners-dialog.component.scss'],
    standalone: false
})
export class PaybyDinersDialogComponent {
	$storage: any;
	arrPlaceholders;

	roundPrecision = 0;
	currencyFormat = '1.0-0';

	payload: any = {
		amount: 0
	}

	constructor(
		public appService: AppService,
		public dialogRef: MatDialogRef<PaybyDinersDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any
	) {
		this.arrPlaceholders = new Array(40);
		this.$storage = this.data.$storage;
		this.payload = {
			... {
				dinersCount: this.$storage.order.dinersCount || 2,
				selectedCount: 1,
			}, ...this.data.payByDinersResult
		}
		this.addDinersCount(0);
		let currencyDenom = _.get(this.$storage.rosConfig.currencySettings, 'minimalTipDenomination', 100);
		switch (currencyDenom) {
			case 1:
				this.roundPrecision = 2;
				this.currencyFormat = '1.2-2';
				break;
			case 10:
				this.roundPrecision = 1;
				this.currencyFormat = '1.1-1';
				break;
		}
	}

	calculateAMount() {
		this.payload.amount = _.round((this.payload.selectedCount / this.payload.dinersCount) * this.$storage.order.itemsTotal, this.roundPrecision);
	}

	addDinersCount(op) {
		let payload = this.payload;
		let newOP = payload.dinersCount + op;
		newOP = Math.max(2, newOP);
		newOP = Math.min(40, newOP);
		payload.dinersCount = newOP;
		this.addSelectedCount(0);
	}
	addSelectedCount(op) {
		let payload = this.payload;
		let newOP = payload.selectedCount + op;
		newOP = Math.max(1, newOP);
		newOP = Math.min(newOP, 40);
		if (newOP > payload.dinersCount) payload.dinersCount = newOP;
		payload.selectedCount = newOP;
		this.calculateAMount();
	}

	cancel() {
		this.dialogRef.close();
	}

	apply() {
		this.dialogRef.close(this.payload);
	}

}
